import type { Filters, OverrideValues } from '@/interfaces';

import urlValues from '@/resources/urlValues.json';

export const browserUrlDisplayValues: OverrideValues<Partial<Filters>, Record<string, string>> = {
    sort: urlValues.sorting,
    meals: urlValues.amenities.meals,
    facilities: urlValues.amenities.facilities,
    activities: urlValues.amenities.activities,
};
